import React from 'react'
import { useGetSchoolCourses, useGetSchoolCoursesList, useGetSkillFourTeachersCourses, useGetSkillToSchoolCourses } from '../../assets/nodeApi/getApi/getSchoolApi'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { Box, Button, Grid2, Typography } from '@mui/material';
import SchoolMyCourseCard from '../../shared/components/school/SchoolMyCourseCard';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { GridChildren } from '../../shared/utils/LingtBlueContainer';
import { Grid_Gap, Website_Url } from '../../shared/constants';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useNavigate } from 'react-router-dom';
import { useProcessedCourses } from '../../shared/hook/useProcessedCourses';

const SchoolDashbaord = () => {
  const navigate = useNavigate();
  const { data: CourseList, isLoading: isLoadingCourseList } = useGetSchoolCoursesList();
  // const { data: SkilltoSchoolCourses, isLoading: isLoadingSkilltoSchool } = useGetSkillToSchoolCourses();
  // const { data: SkillFourTeachersCourses, isLoading: isLoadingSkillFourTeachers } = useGetSkillFourTeachersCourses();
    const { skill2SchoolCourses, upSkill4TeacherCourses, isLoading } = useProcessedCourses()
  return (
    <>
      <NormalContainerWithHeader headerText={"My Courses"} RightContent={CourseList?.data?.length > 2 && <Button variant='outlined'
        onClick={() => { navigate('/school/mycourses') }}
      >View More</Button>}>

        <Grid2 container spacing={Grid_Gap}>
          {isLoadingCourseList ? (
            [...Array(2)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : CourseList?.data?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography variant="body1">Course not found.</Typography>
            </Box>
          ) : (
            CourseList?.data?.slice(0, 2)?.map((item, index) => (
              <GridChildren index={index} key={index}>
                <SchoolMyCourseCard item={item}
                  details={
                    [
                      { label: "Price", value:`₹ ${item?.price}` },
                      { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                      { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                    ]
                  }
                  title={item?.title}
                />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider />
      <NormalContainerWithHeader headerText={"Skill 2 School"} RightContent={skill2SchoolCourses?.length > 2 && <Button variant='outlined'
        onClick={() => { navigate('/school/explorecourses') }}
      >View More</Button>}>
        <Grid2 container spacing={Grid_Gap}>
          {isLoading ? (
            [...Array(2)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : skill2SchoolCourses?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography variant="h6">Course not found.</Typography>
            </Box>
          ) : (
            skill2SchoolCourses?.slice(0, 2)?.map((item, index) => (
              <GridChildren index={index} key={index}>
                <SchoolMyCourseCard
                  buttonText={"Purchase Now"}
                  buttonAction={() => { window.location.href = `${Website_Url}CourseDetail/${item?.slug}/Skill 2 School` }}
                  item={item}
                  details={[
                    { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                    { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                  ]}
                  title={item?.title}
                />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider />
      <NormalContainerWithHeader
        headerText={"Skill 4 Teachers"}
        RightContent={upSkill4TeacherCourses?.length > 2 && <Button variant='outlined'

          onClick={() => { navigate('/school/explorecourses') }}
        >View More</Button>}>
        <Grid2 container spacing={Grid_Gap}>
          {isLoading ? (
            [...Array(2)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : upSkill4TeacherCourses?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography variant="h6">Course not found.</Typography>
            </Box>
          ) : (
            upSkill4TeacherCourses?.slice(0, 2)?.map((item, index) => (
              <GridChildren index={index} key={index}>
                <SchoolMyCourseCard
                  buttonText={"Purchase Now"}
                  buttonAction={() => { window.location.href = `${Website_Url}CourseDetail/${item?.slug}/Upskill 4 Teacher` }}
                  item={item}
                  title={item?.title}
                  details={[
                    { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                    { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                  ]}
                />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>


    </>
  )
}

export default SchoolDashbaord
